<template>
  <div :class="[sizeClasses, 'overflow-hidden bg-slate-200 flex-shrink-0 z-max-plus']">
    <img
      v-if="avatar"
      :src="avatar"
      :alt="name"
      class="w-full h-full object-cover"
    />
    <div v-else class="w-full h-full flex items-center justify-center text-slate-400 text-sm font-medium">
      {{ initials }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  avatar: String,
  name: String,
  firstName: String,
  lastName: String,
  small: {
    type: Boolean,
    default: false
  }
});

const sizeClasses = computed(() => {
  return props.small ? 'h-16 w-16' : 'h-24 w-24';
});

const initials = computed(() => {
  if (props.firstName || props.lastName) {
    return (props.firstName?.[0] || '') + (props.lastName?.[0] || '');
  }

  if (props.name) {
    const nameParts = props.name.trim().split(' ');
    return nameParts.length > 1
      ? nameParts[0][0] + nameParts[nameParts.length - 1][0]
      : nameParts[0][0] || '';
  }

  return '';
});
</script>
